import type { PublicCategoryStatus } from "@/v2-status-client/status/status.types"
import StatusSummaryRow from "@/v2-status-client/status/summary/StatusSummaryRow"

export type StatusCategoryRowProps = {
  category: PublicCategoryStatus
}

// Category summary row used by the all-platforms overview, where
// every platform card lists its categories one row at a time. No
// services here -- the overview is meant for cross-platform
// scanning, not deep-drilling. The per-platform detail view uses
// `StatusCategoryAccordionItem` instead so the customer can expand
// into the underlying service list on demand.
function StatusCategoryRow(props: Readonly<StatusCategoryRowProps>) {
  const { category } = props
  return (
    <StatusSummaryRow
      as="li"
      name={category.name}
      description={category.description}
      status={category.status}
      summary={category.summary}
      uptimePercent30d={category.uptimePercent30d ?? null}
      // Offset for the two-tier sticky nav so a `#category-…` deep
      // link from the overview lands just below the bar instead of
      // tucked behind it.
      className="px-1 scroll-mt-24"
      // Direct id on the row keeps the deep-link target stable
      // across overview / detail layouts -- a customer who landed
      // on `?platform=all#category-foo` and then narrowed to a
      // single platform finds the same anchor in either view.
      id={`category-${category.id}`}
    />
  )
}

export default StatusCategoryRow
